import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';



const firebaseConfig = {
  apiKey: 'AIzaSyA0GS0nPCU_MpCb9ojDDIm-Jg7MgJQnkMI',
  authDomain: 'adposter-core.firebaseapp.com',
  projectId: 'adposter-core',
  storageBucket: 'adposter-core.firebasestorage.app',
  messagingSenderId: '846430240823',
  appId: '1:846430240823:web:018aa873977c3b7abcbfb2',
  measurementId: 'G-12Q7T9LQDF'
};

// Initialize Firebase once
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Core services
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const functions = getFunctions(app);

// Analytics only if supported
let analytics = null;
if (typeof window !== "undefined") {
  isSupported().then(s => { 
    if (s) analytics = getAnalytics(app); 
  }).catch(() => {});
}

export { db, storage, auth, analytics, functions };
export default app;

